import { NavLink, Outlet } from "react-router-dom";
import AppHeader from "@/components/AppHeader";
import { useAuth, FULL_ROLES } from "@/auth";
import {
  LayoutDashboard, Users, MapPin, UserCog, Link2, CheckCircle2, Vote,
  Sparkles, Building2,
} from "lucide-react";

export default function DashboardLayout() {
  const { user } = useAuth();
  const isFull = FULL_ROLES.includes(user?.role);

  const topLinks = [
    { to: "/dashboard", icon: LayoutDashboard, label: "Resumen", end: true, testid: "nav-overview" },
  ];
  const m1Links = [
    { to: "/dashboard/viabilidad", icon: Sparkles, label: "Viabilidad", testid: "nav-viabilidad" },
  ];
  const m2Links = [
    { to: "/dashboard/estructura", icon: Building2, label: "Resumen módulo", end: true, testid: "nav-estructura" },
    { to: "/dashboard/volunteers", icon: Users, label: "Padrón de voluntarios", testid: "nav-volunteers" },
    { to: "/dashboard/casillas", icon: Vote, label: "Gestión de casillas", testid: "nav-casillas" },
    { to: "/dashboard/coverage", icon: MapPin, label: "Cobertura", testid: "nav-coverage" },
  ];
  if (isFull) {
    m2Links.push({ to: "/dashboard/users", icon: UserCog, label: "Usuarios y roles", testid: "nav-users" });
    m2Links.push({ to: "/dashboard/links", icon: Link2, label: "Enlaces de reclutamiento", testid: "nav-links" });
    m2Links.push({ to: "/dashboard/links/approvals", icon: CheckCircle2, label: "Aprobaciones", testid: "nav-approvals" });
  }

  return (
    <div className="min-h-screen bg-slate-50" data-testid="dashboard-layout">
      <AppHeader />
      <div className="max-w-7xl mx-auto px-6 py-8 grid grid-cols-1 lg:grid-cols-12 gap-6">
        <aside className="lg:col-span-3">
          <nav className="surface-card p-3 sticky top-24" data-testid="sidebar-nav">
            <div className="px-3 py-2 tracking-label text-slate-500">Navegación</div>
            <ul className="space-y-1">
              {topLinks.map((l) => (
                <SidebarLink key={l.to} link={l} />
              ))}
            </ul>

            <SidebarSection label="M1 · Viabilidad" />
            <ul className="space-y-1">
              {m1Links.map((l) => (
                <SidebarLink key={l.to} link={l} />
              ))}
            </ul>

            <SidebarSection label="M2 · Construcción de estructura" />
            <ul className="space-y-1">
              {m2Links.map((l) => (
                <SidebarLink key={l.to} link={l} />
              ))}
            </ul>
          </nav>
        </aside>
        <section className="lg:col-span-9 min-w-0">
          <Outlet />
        </section>
      </div>
    </div>
  );
}

function SidebarSection({ label }) {
  return (
    <div className="px-3 pt-4 pb-1 text-[10px] uppercase tracking-[0.25em] text-slate-400 font-semibold">
      {label}
    </div>
  );
}

function SidebarLink({ link }) {
  const Icon = link.icon;
  return (
    <li>
      <NavLink
        to={link.to}
        end={link.end}
        className={({ isActive }) =>
          `flex items-center gap-2 px-3 py-2 rounded text-sm transition-colors ${
            isActive
              ? "bg-slate-900 text-white"
              : "text-slate-700 hover:bg-slate-100"
          }`
        }
        data-testid={link.testid}
      >
        <Icon className="w-4 h-4" /> {link.label}
      </NavLink>
    </li>
  );
}
